import { AppTextService } from '@fi-shared/app-text';
import { FiDateFormatOptions } from '@fi-shared/utils/format-date';
import { FiUpgradeStatusType } from './upgrade-status-type';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

export class FranchiseIntranetUpgradeModel {
    Id: number;
    Description: string;
    VersionMajor: number;
    VersionMinor: number;
    UpgradedOn: Date;
    UpgradeOn: any;
    VersionNumberText: string;
    UpgradeStatusType: number;
    CreatedByUserId: number;
    CreatedByUserName: string;
    CreatedOn: Date;
    CreatedOnDate: string;
    ChangedByUserId: number;
    ChangedByUserName: string;
    ChangedOn: Date;
    ChangedOnDate: string;
    IsReadOnlyMode: boolean;
    UpgradeEndTime: any;
    InternalDescription: any;
    CustomerInformation: any;
    UpgradeVersionType: any;
    SecondsUntilUpgradeStart: any;

    constructor(fiFormatDateService: FiFormatDateService) {
        this.Id = 0;
        this.Description = '';
        this.VersionMajor = 1;
        this.VersionMinor = 0;
        this.UpgradedOn = new Date();
        this.VersionNumberText = '';
        this.UpgradeStatusType = FiUpgradeStatusType.Upcoming;
        this.CreatedByUserId = 1;
        this.CreatedByUserName = '';
        this.CreatedOn = new Date();
        this.CreatedOnDate = fiFormatDateService.formatDate(this.CreatedOn, FiDateFormatOptions);
        this.ChangedByUserId = 1;
        this.ChangedByUserName = '';
        this.ChangedOn = new Date();
        this.ChangedOnDate = fiFormatDateService.formatDate(this.ChangedOn, FiDateFormatOptions);
        this.IsReadOnlyMode = true;
        this.UpgradeEndTime = null;
        this.InternalDescription = null;
        this.CustomerInformation = null;
        this.UpgradeVersionType = null;
        this.SecondsUntilUpgradeStart = null;
    }

    getUpgradeStatusTypeText(appTextService: AppTextService) {
        switch (this.UpgradeStatusType) {
            case FiUpgradeStatusType.Upcoming:
                return appTextService.get('upgrade.upcoming');
            case FiUpgradeStatusType.Completed:
                return appTextService.get('common.completed');
            case FiUpgradeStatusType.Cancelled:
                return appTextService.get('common.cancelled');
        }
    }

    Initialize(franchiseIntranetUpgrade, fiFormatDateService: FiFormatDateService, Language?) {
        this.Id = franchiseIntranetUpgrade.Id;
        this.VersionMajor = franchiseIntranetUpgrade.VersionMajor;
        this.VersionMinor = franchiseIntranetUpgrade.VersionMinor;
        this.VersionNumberText = franchiseIntranetUpgrade.VersionNumberText;
        this.UpgradeOn = franchiseIntranetUpgrade.UpgradeOn;
        this.UpgradeStatusType = franchiseIntranetUpgrade.UpgradeStatusType;
        this.CreatedByUserId = franchiseIntranetUpgrade.CreatedByUserId;
        this.CreatedByUserName = franchiseIntranetUpgrade.CreatedByUserName;
        this.CreatedOn = franchiseIntranetUpgrade.CreatedOn;
        this.CreatedOnDate = fiFormatDateService.formatDate(this.CreatedOn, FiDateFormatOptions);
        this.ChangedByUserId = franchiseIntranetUpgrade.ChangedByUserId;
        this.ChangedByUserName = franchiseIntranetUpgrade.ChangedByUserName;
        this.ChangedOn = franchiseIntranetUpgrade.ChangedOn;
        this.ChangedOnDate = fiFormatDateService.formatDate(this.ChangedOn, FiDateFormatOptions);
        this.InternalDescription = franchiseIntranetUpgrade.InternalDescription;
        this.CustomerInformation = franchiseIntranetUpgrade.CustomerInformation;
        this.UpgradeEndTime = franchiseIntranetUpgrade.UpgradeEndTime;
        this.UpgradeVersionType = franchiseIntranetUpgrade.UpgradeVersionType;
        this.SecondsUntilUpgradeStart = franchiseIntranetUpgrade.SecondsUntilUpgradeStart;
    }

    static UpgradeVersionType = {
        MinorUpgrade: {
            Id: 1,
            TextId: 'upgrade.minor',
        },
        MajorUpgrade: {
            Id: 2,
            TextId: 'upgrade.major',
        },
    };

    getVersionTypeName(appTextService: AppTextService) {
        for (let i in FranchiseIntranetUpgradeModel.UpgradeVersionType) {
            if (FranchiseIntranetUpgradeModel.UpgradeVersionType.hasOwnProperty(i)) {
                const obj = FranchiseIntranetUpgradeModel.UpgradeVersionType[i];
                if (obj && obj.Id == this.UpgradeVersionType) return appTextService.get(obj.TextId);
            }
        }
    }
}
